import Crud from '../views/Local/Crud'
import Entity from '../views/Local/View'

let routes = {
    path: '/locais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/locais/view/:id?',
            name: 'ViewLocal',
            component: Entity,
            meta: {
                pageTitle: 'Visualizar Local',
                breadcrumb: [
                    {
                        text: 'Locais',
                        active: false,
                        to: '/locais',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/locais',
            name: 'list-locais',
            component: Crud,
            meta: {
                pageTitle: "Lista de Locais",
                breadcrumb: [
                    {
                        text: "Locais",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
